import React from 'react';
import { useApp } from '../../context/AppContext';
import { shortMonths } from '../../utils/formatters';

function shiftMonth(ym, delta) {
  const [y, m] = ym.split('-').map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

function label(ym) {
  const [y, m] = ym.split('-').map(Number);
  return `${shortMonths[m - 1].toLowerCase()}/${String(y).slice(2)}`;
}

// Chips de navegação de mês (estilo jun/26 | jul/26 | ago/26)
// O chip do meio é o mês selecionado; os laterais navegam
export default function MonthSelector() {
  const { dispatch, currentMonth, nowMonth } = useApp();
  const months = [shiftMonth(currentMonth, -1), currentMonth, shiftMonth(currentMonth, 1)];
  const isCurrent = currentMonth === nowMonth;

  const set = (ym) => dispatch({ type: 'SET_VIEW_MONTH', payload: ym === nowMonth ? null : ym });

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      {months.map((ym, i) => {
        const selected = i === 1;
        return (
          <button
            key={ym}
            onClick={() => !selected && set(ym)}
            style={{
              padding: '6px 14px',
              borderRadius: 99,
              border: selected ? '1px solid var(--gold)' : '1px solid var(--border)',
              background: selected ? 'rgba(201,162,39,0.12)' : 'var(--card-bg)',
              color: selected ? 'var(--gold)' : 'var(--muted)',
              fontWeight: selected ? 700 : 500,
              fontSize: 12,
              cursor: selected ? 'default' : 'pointer',
              transition: 'all 0.15s',
              whiteSpace: 'nowrap',
            }}
          >
            {label(ym)}
          </button>
        );
      })}
      {!isCurrent && (
        <button
          onClick={() => set(nowMonth)}
          title="Voltar para o mês atual"
          style={{
            padding: '6px 10px', borderRadius: 99,
            border: '1px solid var(--border)', background: 'var(--surface2)',
            color: 'var(--text2)', fontWeight: 600, fontSize: 11, cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 5, whiteSpace: 'nowrap',
          }}
        >
          <i className="fas fa-rotate-left" style={{ fontSize: 10 }}></i> hoje
        </button>
      )}
    </div>
  );
}
